export default __webpack_public_path__ + "static/media/quota-phil.478f5d5a.svg";